module.exports = __webpack_public_path__ + "media/images/athletes/1377-ff051b2d979078fb41ed24c0413f1839.png";